// Social links are typed by owners in many shapes: "https://instagram.com/x", "www.instagram.com/x",
// "instagram.com/x", "@x", "x", even "Moon Magic Floret". Used as-is in href, anything without
// "https://" becomes a link INSIDE Cheesta (/business/@x -> a 404 page, also for Google).
// These helpers turn each into a full outside link, or null when it cannot be one.

export type SocialNetwork = 'instagram' | 'facebook' | 'telegram' | 'whatsapp';

const HOSTS: Record<SocialNetwork, string> = {
    instagram: 'https://www.instagram.com/',
    facebook: 'https://www.facebook.com/',
    telegram: 'https://t.me/',
    whatsapp: 'https://wa.me/',
};

// A username each network accepts: letters, digits, dot, underscore (Facebook also -).
const HANDLE = /^[A-Za-z0-9._-]{2,80}$/;

export const socialUrl = (network: SocialNetwork, raw?: string | null): string | null => {
    let value = String(raw || '').trim();
    if (!value) return null;
    if (network === 'whatsapp') {
        if (/^https?:\/\//i.test(value)) return value;
        const digits = value.replace(/\D/g, '');
        return digits.length >= 8 ? `${HOSTS.whatsapp}${digits.replace(/^0/, '61')}` : null;
    }
    if (/^https?:\/\//i.test(value)) return value;
    // "www.instagram.com/x", "instagram.com/x", "fb.com/x", "t.me/x" ...
    if (/^(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)+\//i.test(value) || /^(www\.)?(instagram|facebook|fb|t)\.(com|me)\b/i.test(value)) {
        return `https://${value.replace(/^\/+/, '')}`;
    }
    value = value.replace(/^@+/, '');
    // A plain username. Anything else (spaces, a business name) is not a link.
    return HANDLE.test(value) ? `${HOSTS[network]}${value}` : null;
};

export const websiteUrl = (raw?: string | null): string | null => {
    const value = String(raw || '').trim();
    if (!value || /\s/.test(value)) return null;
    if (/^https?:\/\//i.test(value)) return value;
    return /^[a-z0-9-]+(\.[a-z0-9-]+)+(\/.*)?$/i.test(value.replace(/^www\./i, '')) ? `https://${value}` : null;
};
